import { Component } from '@angular/core';

@Component({
    selector: 'app-contact',
    templateUrl: './contact.component.html',
})
export class ContactComponent {
    title = 'Contact';
}



// WEBPACK FOOTER //
// /home/ubuntu/spina-me/source/src/app/contact/contact.component.ts